export default __webpack_public_path__ + "static/media/img_muslinTwoBunny_rg_p.e0a64479.jpg";